/* CLUB 1984-style theme behaviors: transparent header, search overlay, mobile drawer, carousels. */
(function () {
  "use strict";

  var ANNOUNCEMENT_HEIGHT = 36;

  function lockScroll(lock) {
    document.body.classList.toggle("c84-lock", lock);
  }

  /* ---------- Header: transparent until the page scrolls past the announcement bar ---------- */
  function initHeader() {
    var header = document.querySelector("[data-c84-header]");
    if (!header) return;
    var transparentAllowed = header.hasAttribute("data-transparent");
    var nav = header.querySelector(".c84-nav");
    var navHovered = false;
    var searchOpen = false;

    function update() {
      var transparent = transparentAllowed && window.scrollY < ANNOUNCEMENT_HEIGHT && !navHovered && !searchOpen;
      header.classList.toggle("is-transparent", transparent);
    }
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    if (nav) {
      nav.addEventListener("mouseenter", function () { navHovered = true; update(); });
      nav.addEventListener("mouseleave", function () { navHovered = false; update(); });
      nav.addEventListener("focusin", function () { navHovered = true; update(); });
      nav.addEventListener("focusout", function () { navHovered = false; update(); });
    }
    update();

    /* Search overlay */
    var search = document.querySelector("[data-c84-search]");
    var shade = document.querySelector("[data-c84-search-shade]");
    function setSearch(open) {
      if (!search) return;
      searchOpen = open;
      search.classList.toggle("is-open", open);
      search.setAttribute("aria-hidden", String(!open));
      if (shade) shade.classList.toggle("is-open", open);
      lockScroll(open);
      update();
      if (open) {
        var input = search.querySelector("input");
        setTimeout(function () { input && input.focus(); }, 50);
      }
    }
    document.querySelectorAll("[data-c84-search-open]").forEach(function (btn) {
      btn.addEventListener("click", function (e) { e.preventDefault(); setSearch(true); });
    });
    document.querySelectorAll("[data-c84-search-close]").forEach(function (btn) {
      btn.addEventListener("click", function () { setSearch(false); });
    });

    /* Mobile drawer */
    var drawer = document.querySelector("[data-c84-drawer]");
    var overlay = document.querySelector("[data-c84-drawer-overlay]");
    function closeSubmenus() {
      if (!drawer) return;
      drawer.querySelectorAll(".c84-drawer__sub.is-open").forEach(function (s) { s.classList.remove("is-open"); });
    }
    function setDrawer(open) {
      if (!drawer) return;
      drawer.classList.toggle("is-open", open);
      drawer.setAttribute("aria-hidden", String(!open));
      if (overlay) overlay.classList.toggle("is-open", open);
      lockScroll(open);
      if (!open) setTimeout(closeSubmenus, 350);
    }
    document.querySelectorAll("[data-c84-drawer-open]").forEach(function (btn) {
      btn.addEventListener("click", function () { setDrawer(true); });
    });
    document.querySelectorAll("[data-c84-drawer-close]").forEach(function (btn) {
      btn.addEventListener("click", function () { setDrawer(false); });
    });
    if (drawer) {
      drawer.querySelectorAll("[data-c84-sub-open]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var sub = document.getElementById(btn.getAttribute("data-c84-sub-open"));
          if (sub) sub.classList.add("is-open");
          btn.setAttribute("aria-expanded", "true");
        });
      });
      drawer.querySelectorAll("[data-c84-sub-back]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var sub = btn.closest(".c84-drawer__sub");
          if (sub) sub.classList.remove("is-open");
        });
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      setSearch(false);
      setDrawer(false);
    });
  }

  /* ---------- Carousels: prev/next buttons, disabled states, mouse drag ---------- */
  function initCarousel(root) {
    var slider = root.querySelector(".c84-slider");
    var prev = root.querySelector("[data-c84-prev]");
    var next = root.querySelector("[data-c84-next]");
    if (!slider) return;

    function step() {
      var item = slider.querySelector(".c84-slider__item");
      var grid = slider.querySelector(".c84-slider__grid");
      var gap = grid ? parseFloat(getComputedStyle(grid).columnGap) || 0 : 0;
      return item ? item.offsetWidth + gap : slider.clientWidth;
    }
    function updateButtons() {
      if (prev) prev.disabled = slider.scrollLeft <= 1;
      if (next) next.disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1;
    }
    if (prev) prev.addEventListener("click", function () { slider.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { slider.scrollBy({ left: step(), behavior: "smooth" }); });
    slider.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);
    updateButtons();

    /* Mouse drag (touch uses native scrolling) */
    var startX = 0, startLeft = 0, dragging = false, moved = false;
    slider.addEventListener("pointerdown", function (e) {
      if (e.pointerType !== "mouse" || e.button !== 0) return;
      dragging = true; moved = false; startX = e.clientX; startLeft = slider.scrollLeft;
    });
    window.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; slider.classList.add("is-dragging"); }
      if (moved) slider.scrollLeft = startLeft - dx;
    });
    window.addEventListener("pointerup", function () {
      if (!dragging) return;
      dragging = false;
      slider.classList.remove("is-dragging");
    });
    slider.addEventListener("click", function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
    slider.addEventListener("dragstart", function (e) { e.preventDefault(); });
  }

  /* ---------- Footer accordions stay open on desktop ---------- */
  function initDisclosures() {
    var mq = window.matchMedia("(min-width: 768px)");
    function sync() {
      document.querySelectorAll("[data-c84-disclosure]").forEach(function (d) {
        if (mq.matches) d.setAttribute("open", "");
        else if (!d.hasAttribute("data-user-open")) d.removeAttribute("open");
      });
    }
    document.querySelectorAll("[data-c84-disclosure] summary").forEach(function (s) {
      s.addEventListener("click", function (e) {
        if (mq.matches) { e.preventDefault(); return; }
        var d = s.parentElement;
        if (d.hasAttribute("open")) d.removeAttribute("data-user-open");
        else d.setAttribute("data-user-open", "");
      });
    });
    mq.addEventListener ? mq.addEventListener("change", sync) : mq.addListener(sync);
    sync();
  }

  /* ---------- Money ---------- */
  function moneyFormat() {
    var el = document.querySelector("[data-c84-money-format]");
    try { return el ? JSON.parse(el.textContent) : "€{{amount_with_comma_separator}}"; } catch (e) { return "€{{amount}}"; }
  }
  function formatMoney(cents, format) {
    format = format || moneyFormat();
    function fmt(n, decimals, thousands, dec) {
      var fixed = (n / 100).toFixed(decimals);
      var parts = fixed.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(dec);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case "amount_no_decimals": return fmt(cents, 0, ",", ".");
        case "amount_with_comma_separator": return fmt(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return fmt(cents, 0, ".", ",");
        case "amount_with_apostrophe_separator": return fmt(cents, 2, "'", ".");
        case "amount_with_space_separator": return fmt(cents, 2, " ", ",");
        default: return fmt(cents, 2, ",", ".");
      }
    });
  }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/"; }

  /* ---------- Cart drawer + AJAX cart ---------- */
  var cartDrawer = null;
  var cartReturnFocus = null;
  var cartScrollState = null;
  function lockCartBackground() {
    if (cartScrollState) return;
    var body = document.body;
    cartScrollState = { x: window.scrollX, y: window.scrollY, position: body.style.position, top: body.style.top, left: body.style.left, width: body.style.width };
    document.documentElement.classList.add("c84-cart-locked");
    body.classList.add("c84-cart-locked");
    body.style.position = "fixed";
    body.style.top = -cartScrollState.y + "px";
    body.style.left = -cartScrollState.x + "px";
    body.style.width = "100%";
  }
  function unlockCartBackground() {
    if (!cartScrollState) return;
    var saved = cartScrollState;
    cartScrollState = null;
    var body = document.body;
    body.style.position = saved.position;
    body.style.top = saved.top;
    body.style.left = saved.left;
    body.style.width = saved.width;
    body.classList.remove("c84-cart-locked");
    document.documentElement.classList.remove("c84-cart-locked");
    window.scrollTo(saved.x, saved.y);
  }
  function loadCartDrawer() {
    return fetch(root() + "cart", { headers: { Accept: "text/html" } })
      .then(function (res) { if (!res.ok) throw new Error("Unable to load cart"); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("[data-c84-cart-page]");
        if (!fresh) throw new Error("Unable to load cart");
        cartDrawer.querySelector("[data-c84-cart-content]").replaceChildren(fresh);
      });
  }
  function cartEnabled() { return cartDrawer && cartDrawer.getAttribute("data-enabled") !== "false"; }
  function openCart() {
    if (!cartDrawer) return;
    cartReturnFocus = document.activeElement;
    cartDrawer.classList.add("is-open");
    cartDrawer.setAttribute("aria-hidden", "false");
    var shade = document.querySelector("[data-c84-cd-shade]");
    if (shade) shade.classList.add("is-open");
    lockScroll(true);
    lockCartBackground();
    cartDrawer.querySelector("[data-c84-cd-close]").focus();
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove("is-open");
    cartDrawer.setAttribute("aria-hidden", "true");
    var shade = document.querySelector("[data-c84-cd-shade]");
    if (shade) shade.classList.remove("is-open");
    lockScroll(false);
    unlockCartBackground();
    if (document.body.classList.contains("template-cart")) { window.location.href = root(); return; }
    if (cartReturnFocus && cartReturnFocus.isConnected) cartReturnFocus.focus();
  }
  function renderCart(html) {
    if (!cartDrawer || !html) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var fresh = doc.querySelector("[data-c84-cd-root]");
    var current = cartDrawer.querySelector("[data-c84-cd-root]");
    if (fresh && current) current.innerHTML = fresh.innerHTML;
    var countMatch = fresh && fresh.querySelector(".c84-cd__title span");
    var count = countMatch ? parseInt(countMatch.textContent.replace(/\D/g, ""), 10) || 0 : 0;
    document.querySelectorAll("[data-c84-cart-count]").forEach(function (el) {
      el.hidden = count === 0;
      var inner = el.querySelector("span");
      if (inner) inner.textContent = count;
    });
  }
  function cartPage() { return document.querySelector("[data-c84-cart-page]"); }
  function renderCartPage(html) {
    var pageEl = cartPage();
    if (!pageEl || !html) return;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var fresh = doc.querySelector("[data-c84-cart-page]");
    if (fresh) pageEl.replaceWith(fresh);
  }
  function cartRequest(url, body) {
    if (cartDrawer) cartDrawer.classList.add("is-busy");
    var pageEl = cartPage();
    if (pageEl) pageEl.classList.add("is-busy");
    if (pageEl) {
      body.sections = pageEl.getAttribute("data-section-id");
      body.sections_url = root() + "cart";
    }
    return fetch(root() + url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (data) {
        if (cartDrawer) cartDrawer.classList.remove("is-busy");
        if (pageEl) pageEl.classList.remove("is-busy");
        if (!res.ok || data.status) throw new Error(data.description || data.message || "Error");
        if (data.sections && pageEl) {
          renderCartPage(data.sections[pageEl.getAttribute("data-section-id")]);
        }
        if (!pageEl && cartEnabled()) return loadCartDrawer().then(function () { return data; });
        return data;
      });
    }).catch(function (err) {
      if (cartDrawer) cartDrawer.classList.remove("is-busy");
      if (pageEl) pageEl.classList.remove("is-busy");
      throw err;
    });
  }
  function addToCart(variantId, quantity) {
    if (!cartEnabled()) {
      var f = document.createElement("form");
      f.method = "post"; f.action = root() + "cart/add";
      f.innerHTML = '<input name="id" value="' + variantId + '"><input name="quantity" value="' + (quantity || 1) + '">';
      document.body.appendChild(f); f.submit();
      return Promise.resolve();
    }
    var minWait = new Promise(function (r) { setTimeout(r, 750); });
    return Promise.all([cartRequest("cart/add.js", { items: [{ id: Number(variantId), quantity: quantity || 1 }] }), minWait])
      .then(function () {
        return new Promise(function (resolve) {
          requestAnimationFrame(function () { requestAnimationFrame(function () { openCart(); resolve(); }); });
        });
      });
  }
  function changeLine(key, quantity) {
    return cartRequest("cart/change.js", { id: key, quantity: Math.max(0, quantity) }).catch(function (err) { window.alert(err.message); });
  }
  function initCartDrawer() {
    var existingCart = cartPage();
    var editorMode = !!(window.Shopify && window.Shopify.designMode);
    if (!editorMode) {
    var shade = document.createElement("div");
    shade.className = "c84-cd-shade";
    shade.setAttribute("data-c84-cd-shade", "");
    shade.setAttribute("data-c84-cd-close", "");
    document.body.appendChild(shade);
    cartDrawer = document.createElement("div");
    cartDrawer.className = "c84-cd c84-cart-panel";
    cartDrawer.setAttribute("data-c84-cd", "");
    cartDrawer.setAttribute("role", "dialog");
    cartDrawer.setAttribute("aria-modal", "true");
    cartDrawer.setAttribute("aria-label", "Your bag");
    cartDrawer.setAttribute("aria-hidden", "true");
    cartDrawer.innerHTML = '<button type="button" class="c84-cart-panel__close" data-c84-cd-close aria-label="Close cart">&times;</button><div data-c84-cart-content></div>';
    document.body.appendChild(cartDrawer);
    if (existingCart) {
      cartDrawer.querySelector("[data-c84-cart-content]").appendChild(existingCart);
      requestAnimationFrame(openCart);
    }
    // Stop gestures on the backdrop, but retain scrolling within the drawer.
    ["touchmove", "wheel"].forEach(function (eventName) {
      shade.addEventListener(eventName, function (e) { e.preventDefault(); }, { passive: false });
    });
    }
    document.addEventListener("click", function (e) {
      var t = e.target;
      var opener = t.closest("[data-c84-cart-open], .c84-cart-link");
      if (opener && editorMode) { e.preventDefault(); window.location.href = root() + "cart"; return; }
      if (opener && cartEnabled()) {
        e.preventDefault();
        loadCartDrawer().then(openCart).catch(function () { window.location.href = root() + "cart"; });
        return;
      }
      if (t.closest("[data-c84-cd-close]")) { closeCart(); return; }
      var qty = t.closest("[data-c84-qty]");
      if (qty) { changeLine(qty.getAttribute("data-key"), parseInt(qty.getAttribute("data-c84-qty"), 10)); return; }
      var quick = t.closest("[data-c84-quick-add]");
      if (quick && !quick.disabled) {
        quick.classList.add("is-adding");
        cartRequest("cart/add.js", { items: [{ id: Number(quick.getAttribute("data-c84-quick-add")), quantity: 1 }] })
          .catch(function (err) { quick.classList.remove("is-adding"); window.alert(err.message); });
        return;
      }
      var chip = t.closest("[data-c84-chip]");
      if (chip && !chip.disabled) {
        var card = chip.closest("[data-c84-look-card]");
        card.querySelectorAll("[data-c84-chip]").forEach(function (c) { c.classList.toggle("is-on", c === chip); });
        var addBtn = card.querySelector("[data-c84-look-add]");
        if (addBtn) addBtn.setAttribute("data-c84-look-add", chip.getAttribute("data-c84-chip"));
        return;
      }
      var lookAdd = t.closest("[data-c84-look-add]");
      if (lookAdd && !lookAdd.disabled) {
        if (lookAdd.classList.contains("is-loading")) return;
        lookAdd.classList.add("is-loading");
        addToCart(lookAdd.getAttribute("data-c84-look-add"), 1)
          .catch(function (err) { window.alert(err.message); })
          .then(function () { setTimeout(function () { lookAdd.classList.remove("is-loading"); }, 400); });
      }
    });
    document.addEventListener("change", function (e) {
      var input = e.target.closest("[data-c84-qty-input]");
      if (input) changeLine(input.getAttribute("data-key"), parseInt(input.value, 10) || 0);
    });
    document.addEventListener("keydown", function (e) {
      if (!cartDrawer || !cartDrawer.classList.contains("is-open")) return;
      if (e.key === "Escape") { closeCart(); return; }
      if (e.key === "Tab") {
        var nodes = Array.from(cartDrawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), [tabindex="0"]')).filter(function (n) { return n.getClientRects().length; });
        var first = nodes[0], last = nodes[nodes.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(section) {
    var form = section.querySelector("form.c84-product-form, [data-c84-product-form]");
    var jsonEl = section.querySelector("[data-c84-product-json]");
    if (!form || !jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var inventory = {};
    try { inventory = JSON.parse(section.querySelector("[data-c84-inventory]").textContent); } catch (e) {}
    var idInput = form.querySelector("[data-c84-variant-id]");
    var atc = form.querySelector("[data-c84-atc]");
    var errorEl = form.querySelector("[data-c84-form-error]");
    var gallery = section.querySelector("[data-c84-gallery]");
    var thumbs = section.querySelector("[data-c84-thumbs]");
    var sticky = section.querySelector("[data-c84-sticky-atc]");
    var currentVariant = product.variants.find(function (v) { return String(v.id) === idInput.value; }) || product.variants[0];

    function selectedOptions() {
      return product.options.map(function (_, i) {
        var checked = form.querySelector('[data-c84-option="' + i + '"] input:checked');
        if (checked) return checked.value;
        var hidden = form.querySelector('[data-c84-option-hidden="' + i + '"]');
        if (hidden) return hidden.value;
        return currentVariant.options[i];
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function updateAvailability(opts) {
      product.options.forEach(function (_, i) {
        form.querySelectorAll('[data-c84-option="' + i + '"] input').forEach(function (input) {
          var test = opts.slice(); test[i] = input.value;
          var match = findVariant(test);
          input.classList.toggle("is-unavailable", !match || !match.available);
        });
      });
    }
    function updateBadges(variant) {
      var inv = inventory[variant.id] || { qty: 0, tracked: false };
      section.querySelectorAll("[data-c84-badge]").forEach(function (b) {
        var mode = b.getAttribute("data-c84-badge");
        var threshold = parseInt(b.getAttribute("data-threshold"), 10) || 0;
        var low = inv.tracked && inv.qty <= threshold;
        var show = mode === "always" ||
          (mode === "available" && variant.available) ||
          (mode === "sold_out" && !variant.available) ||
          (mode === "in_stock" && variant.available && !low) ||
          (mode === "low_stock" && variant.available && low);
        b.hidden = !show;
      });
    }
    function scrollToMedia(variant) {
      if (!variant.featured_media || !gallery) return;
      var item = gallery.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      if (!item) return;
      if (window.matchMedia("(max-width: 767.98px)").matches) gallery.scrollTo({ left: item.offsetLeft, behavior: "smooth" });
    }
    function update() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      updateAvailability(opts);
      if (!variant) {
        atc.disabled = true; atc.textContent = atc.getAttribute("data-unavailable");
        return;
      }
      currentVariant = variant;
      idInput.value = variant.id;
      var priceEl = section.querySelector("[data-c84-price]");
      var compareEl = section.querySelector("[data-c84-compare]");
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (compareEl) {
        compareEl.hidden = !(variant.compare_at_price > variant.price);
        if (!compareEl.hidden) compareEl.textContent = formatMoney(variant.compare_at_price);
      }
      if (atc) {
        atc.disabled = !variant.available;
        atc.textContent = variant.available ? atc.getAttribute("data-add") : atc.getAttribute("data-sold");
      }
      var stickyVariant = section.querySelector("[data-c84-sticky-variant]");
      if (stickyVariant) stickyVariant.textContent = variant.title;
      updateBadges(variant);
      scrollToMedia(variant);
      var url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url.toString());
    }
    form.addEventListener("change", function (e) { if (e.target.matches('input[type="radio"]')) update(); });
    section.querySelectorAll("[data-c84-colour-option]").forEach(function (list) {
      var index = list.getAttribute("data-c84-colour-option");
      list.addEventListener("click", function (e) {
        var sw = e.target.closest(".c84-swatch");
        if (!sw) return;
        list.querySelectorAll(".c84-swatch").forEach(function (s) { s.classList.toggle("is-active", s === sw); });
        var hidden = form.querySelector('[data-c84-option-hidden="' + index + '"]');
        var radio = form.querySelector('[data-c84-option="' + index + '"] input[value="' + CSS.escape(sw.getAttribute("data-value")) + '"]');
        if (hidden) hidden.value = sw.getAttribute("data-value");
        if (radio) radio.checked = true;
        update();
      });
    });
    updateAvailability(selectedOptions());

    form.addEventListener("submit", function (e) {
      if (!cartEnabled()) return;
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;
      if (atc.classList.contains("is-loading")) return;
      atc.classList.add("is-loading");
      form.classList.add("is-adding");
      addToCart(idInput.value, 1)
        .then(function () { setTimeout(function () { atc.classList.remove("is-loading"); form.classList.remove("is-adding"); }, 400); })
        .catch(function (err) {
          atc.classList.remove("is-loading"); form.classList.remove("is-adding");
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        });
    });

    /* Mobile gallery thumbnails */
    if (gallery && thumbs) {
      var buttons = thumbs.querySelectorAll("button");
      buttons.forEach(function (b) {
        b.addEventListener("click", function () {
          var item = gallery.children[parseInt(b.getAttribute("data-index"), 10)];
          if (item) gallery.scrollTo({ left: item.offsetLeft, behavior: "smooth" });
        });
      });
      gallery.addEventListener("scroll", function () {
        var i = Math.round(gallery.scrollLeft / (gallery.clientWidth || 1));
        buttons.forEach(function (b, bi) { b.classList.toggle("is-active", bi === i); });
      }, { passive: true });
    }

    /* Size guide panel */
    var sg = section.querySelector("[data-c84-sg]");
    function setSg(open) {
      if (!sg) return;
      sg.classList.toggle("is-open", open);
      sg.setAttribute("aria-hidden", String(!open));
      var shade = sg.nextElementSibling;
      if (shade) shade.classList.toggle("is-open", open);
      lockScroll(open);
    }
    section.querySelectorAll("[data-c84-sg-open]").forEach(function (b) { b.addEventListener("click", function () { setSg(true); }); });
    section.querySelectorAll("[data-c84-sg-close]").forEach(function (b) { b.addEventListener("click", function () { setSg(false); }); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && sg && sg.classList.contains("is-open")) setSg(false); });

    /* Sticky add-to-cart bar: visible once the main button has scrolled above the viewport */
    if (sticky && atc && "IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle("is-visible", show);
        sticky.setAttribute("aria-hidden", String(!show));
      }).observe(atc);
      var stickyAdd = sticky.querySelector("[data-c84-sticky-add]");
      if (stickyAdd) stickyAdd.addEventListener("click", function () {
        if (atc.disabled) { atc.scrollIntoView({ behavior: "smooth", block: "center" }); return; }
        form.requestSubmit ? form.requestSubmit(atc) : atc.click();
      });
      var change = sticky.querySelector("[data-c84-sticky-change]");
      if (change) change.addEventListener("click", function () {
        var opts = section.querySelector("[data-c84-options]") || form;
        opts.scrollIntoView({ behavior: "smooth", block: "center" });
      });
    }
  }

  /* ---------- Delivery estimate ---------- */
  function initDelivery(el) {
    var min = parseInt(el.getAttribute("data-min"), 10) || 0;
    var max = Math.max(min, parseInt(el.getAttribute("data-max"), 10) || 0);
    var cutoff = parseInt(el.getAttribute("data-cutoff"), 10) || 24;
    var skipWeekends = el.getAttribute("data-skip-weekends") === "true";
    var tz = el.getAttribute("data-tz") || "+0000";
    var offsetMin = (tz[0] === "-" ? -1 : 1) * (parseInt(tz.slice(1, 3), 10) * 60 + parseInt(tz.slice(3, 5), 10));
    var dateEl = el.querySelector("[data-c84-delivery-date]");
    var timerEl = el.querySelector("[data-c84-delivery-timer]");
    var locale = el.getAttribute("data-locale") === "en" ? "en-GB" : el.getAttribute("data-locale") || "en-GB";
    function storeNow() { var d = new Date(); return new Date(d.getTime() + (d.getTimezoneOffset() + offsetMin) * 60000); }
    function addDays(start, days) {
      var d = new Date(start);
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        if (skipWeekends && (d.getDay() === 0 || d.getDay() === 6)) continue;
        added++;
      }
      return d;
    }
    function fmt(d) { return d.toLocaleDateString(locale, { day: "numeric", month: "short" }); }
    function tick() {
      var now = storeNow();
      var cut = new Date(now); cut.setHours(cutoff, 0, 0, 0);
      var ship = new Date(now);
      if (now >= cut) { ship.setDate(ship.getDate() + 1); cut.setDate(cut.getDate() + 1); }
      var first = addDays(ship, min), last = addDays(ship, max);
      if (dateEl) dateEl.textContent = min === max ? fmt(first) : fmt(first) + " – " + fmt(last);
      if (timerEl) {
        var s = Math.max(0, Math.floor((cut - now) / 1000));
        var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
        timerEl.textContent = [h, m, sec].map(function (n) { return String(n).padStart(2, "0"); }).join(":");
      }
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- "Style with" dots follow the scroll position ---------- */
  function initLookDots(section) {
    var grid = section.querySelector("[data-c84-look-grid]");
    var dotsEl = section.querySelector("[data-c84-look-dots]");
    if (!grid || !dotsEl) return;
    var cards = grid.children.length;
    for (var i = 0; i < cards; i++) { var d = document.createElement("span"); d.className = "c84-look__dot" + (i === 0 ? " is-on" : ""); dotsEl.appendChild(d); }
    grid.addEventListener("scroll", function () {
      var card = grid.children[0];
      var idx = card ? Math.round(grid.scrollLeft / (card.offsetWidth + 16)) : 0;
      Array.prototype.forEach.call(dotsEl.children, function (d, di) { d.classList.toggle("is-on", di === idx); });
    }, { passive: true });
  }

  /* ---------- Product recommendations ---------- */
  function initRelated(el) {
    var url = el.getAttribute("data-url");
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var fresh = doc.querySelector("[data-c84-related]");
      if (fresh && fresh.innerHTML.trim() && fresh.querySelector(".c84-card")) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  }

  function safe(fn, arg) {
    try { fn(arg); } catch (err) { if (window.console) console.error("[theme]", err); }
  }
  function init() {
    safe(initCartDrawer);
    safe(initHeader);
    document.querySelectorAll("[data-c84-carousel]").forEach(function (el) { safe(initCarousel, el); });
    safe(initDisclosures);
    document.querySelectorAll("[data-c84-product-section]").forEach(function (el) { safe(initProduct, el); });
    document.querySelectorAll("[data-c84-delivery]").forEach(function (el) { safe(initDelivery, el); });
    document.querySelectorAll("[data-c84-look]").forEach(function (el) { safe(initLookDots, el); });
    document.querySelectorAll("[data-c84-related]").forEach(function (el) { safe(initRelated, el); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
